import { Config } from "@forgerock/javascript-sdk";

export const truncateStr = (str) => {
  let maxLength = 25;
  if (str.length <= maxLength) {
    return str;
  }
  const truncateLength = (maxLength - 3) / 2;
  const startPart = str.slice(0, Math.ceil(truncateLength));
  const endPart = str.slice(-Math.floor(truncateLength));
  return `${startPart}...${endPart}`;
};

export function validateEmail(email) {
  let re = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
  return re.test(email);
}

export function validateMobileNumber(mobile) {
  let re = /^(09|\+639)\d{9}$/gm;
  return re.test(mobile);
}

export function validateCardNumber(num) {
  return num.startsWith("1168") && num.length === 19 && num !== "";
}

export function removeDuplicatesByField (array, field) {
  const seen = new Set();
  return array.filter((item) => {
    const key = item[field];
    return seen.has(key) ? false : (seen.add(key), true);
  });
};

export function resetConfig() {
  Config.set({
    clientId: process.env.REACT_APP_WEB_OAUTH_CLIENT,
    redirectUri: `${process.env.REACT_APP_APP_URL}/callback`,
    scope: "openid profile email",
    serverConfig: {
      baseUrl: process.env.REACT_APP_AM_URL,
      timeout: 100000,
    },
    realmPath: process.env.REACT_APP_REALM_PATH,
  });
}

export function startJourney(tree) {
  Config.set({
    clientId: process.env.REACT_APP_WEB_OAUTH_CLIENT,
    redirectUri: `${process.env.REACT_APP_APP_URL}/callback`,
    scope: "openid profile email",
    serverConfig: {
      baseUrl: process.env.REACT_APP_AM_URL,
      timeout: 100000,
    },
    realmPath: process.env.REACT_APP_REALM_PATH,
    tree: tree,
  });
}
